export default __webpack_public_path__ + "static/media/bg-about-us.cf9a123e.jpg";